module.exports = __webpack_public_path__ + "img/提醒.a974b299.svg";